import SelectBox from './selectBox/select';
import SelectTreeComponent from './selectRadio/selectTreeComponent';
import SearchBox from './searchBox/search';
import RadioGroupComponent from './radioGroup/radioGroupComponent';

export default {
  SelectBox,
  SelectTreeComponent,
  SearchBox,
  RadioGroupComponent,
};